import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, PdfColor } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { calcGridRects } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/arrow';

/**
 * Kolicky_Vpravo (Clothespin Left/Right)
 *
 * Layout: Landscape pages with variable grid (3-24 items).
 * Each cell has an image on top and two arrow buttons (left/right) at the bottom.
 *
 * Migrated from C# EduFrame.Img10.Generators.Kolicky__Vpravo
 */
export class KolickyVpravoVlevo implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const page = pdf.addPage(true);
    const margin = PdfUnit.FromMillimeters(5);
    const margin2 = PdfUnit.FromMillimeters(1);

    const count = Math.min(opts.list.length, this.countMax());
    const { rects } = calcGridRects(count, margin, PdfSize.A4H);

    const optionHeight = PdfUnit.FromMillimeters(15);
    const optionWidth = rects[0].width / 2;

    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];
      const r1 = new PdfRect(rect.x, rect.y, rect.width, rect.height - optionHeight);

      page.drawImageCenter(opts.list[i].image, r1);
      page.drawRectangle(GUtil.basePen, null, rect);

      const rr1 = new PdfRect(rect.x, rect.bottom - optionHeight, optionWidth, optionHeight);
      const rr2 = new PdfRect(
        rect.x + optionWidth,
        rect.bottom - optionHeight,
        optionWidth,
        optionHeight
      );
      const rr1a = new PdfRect(
        rect.x + margin2,
        rect.bottom + margin2 - optionHeight,
        optionWidth - 2 * margin2,
        optionHeight - 2 * margin2
      );
      const rr2a = new PdfRect(
        rect.x + margin2 + optionWidth,
        rect.bottom + margin2 - optionHeight,
        optionWidth - 2 * margin2,
        optionHeight - 2 * margin2
      );

      page.drawRectangle(GUtil.basePen, null, rr1);
      page.drawRectangle(GUtil.basePen, null, rr2);
      page.drawArrowLeft(rr1a, PdfBrush.Red);
      page.drawArrowRight(rr2a, new PdfBrush(PdfColor.fromRgb(0, 0, 255)));
    }
  }
}
